import classNames from 'classnames';

import React from 'react';

interface OwnProps {
  when?: boolean;
  bottom?: boolean;
}

type Props = Readonly<React.PropsWithChildren<OwnProps>>;

const Sticky: React.FC<Props> = ({ bottom, when, children }) => {
  const whenExists = when !== null;
  return (
    <div
      className={classNames(bottom ? 'sticky-bottom' : 'sticky-top', {
        'is-valid': when,
        'when-valid': whenExists,
      })}
    >
      {children}
    </div>
  );
};

export default React.memo(Sticky);
